import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { getCopy } from 'utils/copy';
import { smoothScrollTo } from 'utils/smoothScroll';
import s from 'components/templates/landing/landing.sss';

export default class Landing extends Component {
	constructor(props) {
		super(props);
		this.onScrollClick = this.onScrollClick.bind(this);
	}

	onScrollClick() {
		smoothScrollTo('root', this.base.nextElementChild, 750);
	}

	render({ data, isDesktop, active }) {
		let {
			background,
			tt,
			date,
			id,
			scrollArrow
		} = data;

		if (typeof background === 'object') {
			background = isDesktop ? background.src_large : background.src;
		}
		const oneImg = !tt && !date;
		return (
			<div class={joinClasses(s.wrapper, active && s.active)} style={!oneImg && { backgroundImage: `url(${background})` }} id={id} data-section-observed>
				{oneImg && <img class={s.image} src={background} />}
				{scrollArrow && <div class={s.scroll} onClick={this.onScrollClick} />}
				{tt && <img class={s.tt} src={tt.src} style={{ top: tt.top, width: tt.width, left: tt.left }} />}
				{date && <div class={s.date} style={{ bottom: date.bottom, color: date.color, left: date.left }}>{getCopy(date.copy)}</div>}
			</div>
		);
	}

}
